import {mobileTouchFix} from '$c3base/mobile-touch-fix.js';
import {overrideCheckFunction} from '$c3base/check-mobile-nav.js';

overrideCheckFunction(() => {});

let documentBody = null;
let headerBanner = null;
let navigation = null;
let navigationWidth = 0;
let mobileNav = null;
let newsSlider = null;
let headerBannerInterval = null;
let numCounters = [];

$(function(){
    documentBody = $('body');

    navigation = $('header .desktop nav');
    if (navigation.length) {
        navigation.find('.level_1 > li').each(function () {
            navigationWidth += $(this).outerWidth();
            let level2 = $(this).find('.level_2');
            if (level2.length && level2.outerWidth() > $(this).outerWidth()) {
                level2.css({
                    left: -((level2.outerWidth() - $(this).outerWidth()) / 2) + 'px'
                })
            }
        });
        checkMobileNav();
    }

    mobileNav = $('.header-outer-wrap .mobile');
    if (mobileNav.length) {
        mobileNav.find('.menu-button').click(function () {
            mobileNav.toggleClass('open');
            $('body').toggleClass('mobile-nav-open')
        });
    }

    if ($('.accordion-outer-wrap').length) {
        $('.accordion-outer-wrap').each(function () {
            $(this).accordion({
                collapsible: true,
                heightStyle: 'content',
                active: false,
            });
        })
    }
    newsSlider = $('.news-list-view.slider > .row');
    if (newsSlider.length) {

    }

    /**
     * header banner height
     * @type {*|jQuery.fn.init|jQuery|HTMLElement}
     */
    headerBanner = $('.header-banner');
    if (headerBanner.length) {
        headerBannerInterval = setInterval(function () {
            checkBannerHeight();
        },20);
    }

    mobileTouchFix($('.desktop nav'));
    mobileTouchFix($('.mobile nav'));

    $('.mobile').find('.language-menu > div').click(function() {
        $('.language-dropdown').toggle();
    });

    if($('.header-banner').length){
        $('.keywords').show();
    } else{
        $('.keywords').hide();
    }

    $('.numberCounter').each(function() {
        numCounters.push(this);
    });

    initCounter();


});

$(window).on("load", function (e) {

});

$(window).on("scroll", function (e) {
    initCounter();
});

$(window).on("resize", function (e) {
    if (headerBanner && headerBanner.length) {
        checkBannerHeight();
    }
    if (navigation.length) {
        checkMobileNav();
    }
});

function checkMobileNav() {
    if (navigation.width() < navigationWidth) {
        if (!documentBody.hasClass('mobile-menu')) {
            documentBody.addClass('mobile-menu');
        }
    } else {
        if (documentBody.hasClass('mobile-menu')) {
            documentBody.removeClass('mobile-menu');
        }
    }
}

function checkBannerHeight() {
    if (
        parseInt(headerBanner.find('.banner-outer-wrap').height()) <= parseInt(headerBanner.css('height')) &&
        parseInt(headerBanner.find('.banner-outer-wrap').height()) < parseInt(headerBanner.data('initial-height'))) {
        headerBanner.height('auto');
    } else {
        headerBanner.height(headerBanner.data('initial-height'));
        clearInterval(headerBannerInterval);
    }
}

function isScrolledIntoView(elem) {

    let docViewTop = $(window).scrollTop();
    let docViewBottom = docViewTop + $(window).height();

    let elemTop = elem.offset().top;
    let elemBottom = elemTop + elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop - 70 >= docViewTop));

}

function initCounter() {
    if($('.numberCounter.activated').length !== $('.numberCounter').length) {
        $.each(numCounters, function() {
            if(isScrolledIntoView($(this).find('.counterColumn:first-child .counter')) || isScrolledIntoView($(this).find('.counterColumn:last-child .counter'))) {
                if(!$(this).hasClass('activated')) {
                    $(this).find('.counterNumber .counter').each(function () {
                        $(this).prop('Counter', 0).animate({
                            Counter: $(this).data('destinationvalue')
                        }, {
                            duration: 800,
                            easing: 'swing',
                            step: function (now) {
                                if($(this).data('destinationvalue') % 1 === 0) {
                                    let num = Math.ceil(now);
                                    $(this).text(num.toLocaleString());
                                } else {
                                    let num = now * 10;
                                    num = Math.round(num);
                                    num = num / 10;
                                    $(this).text(num.toLocaleString());
                                }
                            }
                        });
                    });
                }
                $(this).addClass('activated');
            }
        });
    }
}